export const items = [
  "Order ID",
  "Ordered on",
  "Shop Products",
  "Address",
  "Payment details",
  "Order Status",
];
